document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll(`.custom-scroll`).forEach(s => new PerfectScrollbar(s));
  document.querySelectorAll(`.custom-scroll-y`).forEach(s => new PerfectScrollbar(s, {suppressScrollY: true,}));
});
